// The global header only exists in Test/Prod, so every member is optional.
export type GlobalHeaderWindow = Window & {
  notifyGlobalHeader?: { openLogonLayer?: (target?: string) => void };
};

/** Sends the advisor through the global header's sign-in, returning them to `url` afterwards. */
export function loginLayerDeeplink(url: string): void {
  (window as GlobalHeaderWindow).notifyGlobalHeader?.openLogonLayer?.(url);
}
